export default __webpack_public_path__ + "static/Averta-Semibold-75ee7f042277266e1fe7776d059d57c6.woff2";